import { compose, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { selectProductVariant as selectProductVariantAction } from 'ggApp/modules/product';
import { registerProductDetailedImpression as registerProductDetailedImpressionAction } from 'ggApp/modules/gaAnalytics';
import { registerProductDetailedImpressionV2 as registerProductDetailedImpressionV2Action } from 'ggApp/modules/gaAnalytics/actions';

const withProductVariantHandler = compose(
    connect(null, (dispatch) =>
        bindActionCreators(
            {
                selectProductVariant: selectProductVariantAction,
                registerProductDetailedImpression: registerProductDetailedImpressionAction,
                registerProductDetailedImpressionV2: registerProductDetailedImpressionV2Action,
            },
            dispatch,
        ),
    ),
    withHandlers({
        changeVariant: (props) => (variantId) => {
            const {
                selectProductVariant,
                registerProductDetailedImpression,
                registerProductDetailedImpressionV2,
            } = props;
            selectProductVariant(variantId);
            registerProductDetailedImpression();
            registerProductDetailedImpressionV2({
                sendToBraze: false,
            });
        },
    }),
);
export default withProductVariantHandler;
